export const getQueryValue = (value: unknown) => {
  if (typeof value === 'string' && value) {
    return value;
  }

  if (Array.isArray(value) && typeof value[0] === 'string' && value[0]) {
    return value[0];
  }

  return undefined;
};

export type QueryLike = Record<string, string | string[] | undefined>;

type CartParamsOptions = {
  cartId?: string | null;
  previousCartId?: string | null;
};

export function withCartParams(
  query: QueryLike,
  params: CartParamsOptions
): QueryLike {
  return {
    ...query,
    ...(params.cartId ? { cartId: params.cartId } : {}),
    ...(params.previousCartId ? { previousCartId: params.previousCartId } : {}),
  };
}

export const normalizeQueryParams = (
  query: QueryLike
): Array<{ param: string; values: number }> => {
  const duplicated: Array<{ param: string; values: number }> = [];

  for (const param of Object.keys(query)) {
    const value = query[param];

    if (!Array.isArray(value)) {
      continue;
    }

    if (value.length > 1) {
      duplicated.push({ param, values: value.length });
    }

    const normalized = getQueryValue(value);

    if (normalized === undefined) {
      delete query[param];
      continue;
    }

    query[param] = normalized;
  }

  return duplicated;
};
